<template>
  <div>
    <form class="form-horizontal">
      <div class="row mb-3">
        <div>
          <div class="form-group row">
            <label class="col-md-3 form-col-label control-label required">
              {{ $t('disciplinaryRecord.studentName') }}
            </label>
            <div class="col-md-9">
              <ts-select-student
                v-model.number="model.student_id"
                @change="onFetchSubject(model.student_id)"
              />
              <div class="validate" v-if="errors.has('student_id')">
                {{ errors.first('student_id') }}
              </div>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-md-3 form-col-label control-label required">
              {{ $t('disciplinaryRecord.subject') }}
            </label>
            <div class="col-md-9">
              <select
                v-model="model.subject_id"
                class="form-control"
                :class="{ 'is-invalid': errors.has('subject_id') }"
              >
                <option value="">{{ $t('select') }}</option>
                <option
                  v-for="(sub, index) in subjects"
                  :key="index"
                  :value="sub.subject_id"
                >
                  {{ sub.subject_name_foreign }}
                </option>
              </select>
              <div class="invalid-feedback" v-if="errors.has('subject_id')">
                {{ errors.first('subject_id') }}
              </div>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-md-3 form-col-label control-label required">
              {{ $t('disciplinaryRecord.disciplinarySubType') }}
            </label>
            <div class="col-md-9">
              <select
                v-model="model.dis_sub_type_id"
                class="form-control"
                @change="fetchActivity()"
                :class="{ 'is-invalid': errors.has('dis_sub_type_id') }"
              >
                <option value="">{{ $t('select') }}</option>
                <option
                  v-for="(sub, index) in disciplinarySubTypes"
                  :key="index"
                  :value="sub.dis_sub_type_id"
                >
                  {{ sub.dis_sub_type_en + '|' + sub.dis_sub_type_kh }}
                </option>
              </select>
              <div
                class="invalid-feedback"
                v-if="errors.has('dis_sub_type_id')"
              >
                {{ errors.first('dis_sub_type_id') }}
              </div>
            </div>
          </div>
          <div
            class="form-group row"
            v-if="
              model.dis_sub_type_id != 18 &&
              model.dis_sub_type_id != 19 &&
              model.dis_sub_type_id != 20
            "
          >
            <label class="col-md-3 form-col-label control-label required">
              {{ $t('disciplinaryRecord.disciplinaryActivity') }}
            </label>
            <div class="col-md-9">
              <select
                v-model="model.dis_activity_id"
                class="form-control"
                :class="{ 'is-invalid': errors.has('dis_activity_id') }"
              >
                <option value="">{{ $t('select') }}</option>
                <option
                  v-for="(act, index) in disciplinaryActivities"
                  :key="index"
                  :value="act.dis_activity_id"
                >
                  {{ act.dis_activity_en + '|' + act.dis_activity_kh }}
                </option>
              </select>
              <div
                class="invalid-feedback"
                v-if="errors.has('dis_activity_id')"
              >
                {{ errors.first('dis_activity_id') }}
              </div>
            </div>
          </div>
          <div
            class="form-group row"
            v-if="model.dis_sub_type_id == 18 || model.dis_sub_type_id == 19"
          >
            <label class="col-md-3 form-col-label control-label required">
              {{ $t('disciplinaryRecord.presidentActivity') }}
            </label>
            <div class="col-md-9">
              <select
                v-model="model.dis_activity_id"
                class="form-control"
                :class="{ 'is-invalid': errors.has('dis_activity_id') }"
              >
                <option value="">{{ $t('select') }}</option>
                <option
                  v-for="(acp, index) in activities"
                  :key="index"
                  :value="acp.dis_activity_id"
                >
                  {{ acp.dis_activity_en + '|' + acp.dis_activity_kh }}
                </option>
              </select>
              <div
                class="invalid-feedback"
                v-if="errors.has('dis_activity_id')"
              >
                {{ errors.first('dis_activity_id') }}
              </div>
            </div>
          </div>
          <div class="form-group row" v-if="model.dis_sub_type_id == 20">
            <label class="col-md-3 form-col-label control-label required">
              {{ $t('disciplinaryRecord.presidentActivity') }}
            </label>
            <div class="col-md-9">
              <select
                v-model="model.dis_activity_id"
                class="form-control"
                :class="{ 'is-invalid': errors.has('dis_activity_id') }"
              >
                <option value="">{{ $t('select') }}</option>
                <option
                  v-for="(acp, index) in presidenactivities"
                  :key="index"
                  :value="acp.dis_activity_id"
                >
                  {{ acp.dis_activity_en + '|' + acp.dis_activity_kh }}
                </option>
              </select>
              <div
                class="invalid-feedback"
                v-if="errors.has('dis_activity_id')"
              >
                {{ errors.first('dis_activity_id') }}
              </div>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-md-3 form-col-label control-label">
              {{ $t('disciplinaryRecord.actionDate') }}
            </label>
            <div class="col-md-9">
              <a-date-picker
                style="width: 100%"
                format="DD-MM-YYYY"
                valueFormat="DD-MM-YYYY"
                v-model="model.dis_action_date"
              ></a-date-picker>
              <div class="validate" v-if="errors.has('dis_action_date')">
                {{ errors.first('dis_action_date') }}
              </div>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-md-3 form-col-label control-label">
              {{ $t('disciplinaryRecord.description') }}
            </label>
            <div class="col-md-9">
              <textarea
                class="form-control"
                v-model="model.dis_action_description"
                rows="2"
              ></textarea>
            </div>
          </div>
        </div>
      </div>
      <div class="text-right">
        <ts-button @click="cancel()">
          {{ $t('cancel') }}
        </ts-button>
        <ts-button
          class="ml-2"
          color="primary"
          :disabled="saving"
          :waiting="saving"
          @click="update"
          v-if="editing == true"
        >
          {{ $t('update') }}
        </ts-button>
        <ts-button
          class="ml-2"
          color="primary"
          :disabled="saving"
          :waiting="saving"
          @click="save"
          v-else
        >
          {{ $t('save') }}
        </ts-button>
      </div>
    </form>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import TsSelectStudent from '@/components/SelectStudent'
import { mapActions, mapState } from 'vuex'
import moment from 'moment'

export default {
  name: 'disciplinary-record-create-form',
  components: {
    TsSelectStudent
  },
  props: ['edit'],
  data () {
    return {
      model: {
        dis_record_id: 0,
        student_id: '',
        dis_sub_type_id: '',
        dis_activity_id: '',
        subject_id: '',
        dis_action_date: moment().format('DD-MM-YYYY'),
        dis_action_description: '',
        dis_activty_id: '',
        dis_status: ''
      },
      subjects: [],
      activities: [],
      presidenactivities:[],
      errors: new Errors(),
      loading: false,
      saving: false,
      editing: false
    }
  },
  mounted () {
    // this.$refs.acp_name_native.focus()
  },
  computed: {
    ...mapState('disciplinaryRecord', [
      'disciplinarySubTypes',
      'disciplinaryActivities'
    ])
  },
  async created () {
    this.loadingPreData = true
    await Promise.all([this.fetchDisciplinarySubType()]).then(() => {
      this.loadingPreData = false
      this.setEdit()
    })
    await Promise.all([this.fetchDisciplinaryActivity()]).then(() => {
      this.loadingPreData = false
      this.setEdit()
    })
  },
  methods: {
    ...mapActions('disciplinaryRecord', [
      'fetchDisciplinarySubType',
      'fetchDisciplinaryActivity',
      'getSubject',
      'getActivity'
    ]),
    cancel () {
      this.editing = false
      this.clearForm()
      this.$emit('cancel')
      this.$emit('fetchData')
      this.$router.push({ name: 'disciplinary-record' })
    },
    onFetchSubject (stuId) {
      this.loading = true
      this.model.subject_id = ''
      this.subjects = []
      if (stuId) {
        this.loading = true
        this.getSubject(stuId)
          .then(response => {
            this.subjects = response[1]
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
    async fetchActivity () {
      this.model.dis_activty_id = null
      await this.getActivity()
        .then(response => {
          this.presidenactivities = response[1].filter(
            el => el.dis_status == 'Presiden 3rd'
          )
          this.activities = response[1].filter(
            el => el.dis_status == 'Presiden 1st'
          )
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },

    async save () {
      this.saving = true
      this.errors = new Errors()
      try {
        let response = await this.$store.dispatch(
          'disciplinaryRecord/create',
          this.model
        )
        this.$toasted.success(response.message)
        this.$emit('fetchData')
        this.cancel()
        this.clearForm()
      } catch (error) {
        this.errors = new Errors(error.errors)
        this.$toasted.error(error.message)
      }
      this.saving = false
    },

    async update () {
      this.saving = true
      this.errors = new Errors()
      try {
        let response = await this.$store.dispatch(
          'disciplinaryRecord/update',
          this.model
        )

        this.$toasted.success(response.message)
        this.editing = false
        this.$emit('fetchData')
        this.$emit('success_update')
        this.cancel()
        this.clearForm()
      } catch (error) {
        this.editing = true
        this.errors = new Errors(error.errors)
        this.$toasted.error(error.message)
      }
      this.saving = false
    },

    setEdit () {
      if (this.edit === null || this.edit === undefined) return
      this.errors = new Errors()
      this.model = {
        dis_record_id: this.edit.dis_record_id,
        dis_action_date: this.edit.dis_action_date,
        dis_action_description: this.edit.dis_action_description,
        dis_sub_type_id: this.edit.dis_sub_type_id,
        dis_activity_id: this.edit.dis_activity_id,
        subject_id: this.edit.subject_id,
        student_id: this.edit.student.student_id,
        fetch_subject: this.onFetchSubject(this.edit.student.student_id)
      }
      this.editing = true
    },

    clearForm () {
      this.model = {
        student_id: '',
        dis_sub_type_id: '',
        dis_activity_id: '',
        subject_id: '',
        dis_action_date: moment().format('DD-MM-YYYY'),
        dis_action_description: ''
      }
    }
  },
  watch: {
    edit: {
      handler () {
        if (this.edit) {
          this.setEdit()
          this.editing = true
        }
      }
    }
  }
}
</script>
